import type { GuidedFlowId } from '@wapharma/domain';
import { ADMIN_ROLES, ADMIN_USERS } from '../constants/adminNavLabels';

export type FlowMeta = {
  id: GuidedFlowId;
  /** One phrase: action + goal + entity (dock / guide title). */
  title: string;
  /**
   * Optional deep-link. Omit when the flow tour owns navigation
   * (e.g. inventaire flyout → Catalogue before any create drawer).
   */
  href?: string;
};

export const FLOW_META: Record<string, FlowMeta> = {
  'people-learn-roles': {
    id: 'people-learn-roles',
    title: 'Lire les rôles pour savoir qui peut faire quoi',
    href: ADMIN_ROLES.path,
  },
  'people-create-account': {
    id: 'people-create-account',
    title: 'Créer un compte collègue pour partager le travail',
    href: ADMIN_USERS.path,
  },
  'people-cover-poles': {
    id: 'people-cover-poles',
    title: 'Couvrir catalogue, achat, entrepôt, vente et finance',
    href: ADMIN_USERS.path,
  },
  'people-verify-authority': {
    id: 'people-verify-authority',
    title: 'Vérifier super-admin, rôles et reporting',
    href: ADMIN_ROLES.path,
  },
  'people-verify-sod': {
    id: 'people-verify-sod',
    title: 'Séparer achat/paiement et vente/compta sur les comptes',
    href: ADMIN_USERS.path,
  },
  'catalog-create-product': {
    id: 'catalog-create-product',
    title: 'Créer un produit au catalogue',
  },
  'catalog-create-variant': {
    id: 'catalog-create-variant',
    title: 'Ajouter une variante au produit',
    href: '/catalog',
  },
  'catalog-readiness': {
    id: 'catalog-readiness',
    title: 'Marquer le produit prêt à vendre (pas le stock)',
    href: '/catalog',
  },
  'locations-create': {
    id: 'locations-create',
    title: 'Créer un emplacement d’entrepôt',
    href: '/inventory/locations?create=1',
  },
  'locations-classes': {
    id: 'locations-classes',
    title: 'Définir les classes de stock des lots',
    href: '/inventory/lots',
  },
  'buy-qualify-supplier': {
    id: 'buy-qualify-supplier',
    title: 'Qualifier un fournisseur avant achat',
    href: '/procurement/suppliers?create=1',
  },
  'buy-create-po': {
    id: 'buy-create-po',
    title: 'Émettre un bon de commande fournisseur',
    href: '/procurement/purchase-orders?create=1',
  },
  'receive-po': {
    id: 'receive-po',
    title: 'Réceptionner la commande en quarantaine',
    href: '/procurement/purchase-orders',
  },
  'receive-verify-lot': {
    id: 'receive-verify-lot',
    title: 'Contrôler le lot reçu',
    href: '/inventory/lots',
  },
  'release-lot': {
    id: 'release-lot',
    title: 'Libérer le lot pour la vente',
    href: '/inventory/lots',
  },
  'release-verify-atp': {
    id: 'release-verify-atp',
    title: 'Vérifier la quantité commandable du produit',
    href: '/catalog/products',
  },
  'sell-create-order': {
    id: 'sell-create-order',
    title: 'Créer une commande client',
    href: '/orders?create=1',
  },
  'sell-confirm-ship': {
    id: 'sell-confirm-ship',
    title: 'Confirmer et expédier la commande client',
    href: '/orders',
  },
  'return-order': {
    id: 'return-order',
    title: 'Enregistrer un retour de commande',
    href: '/orders',
  },
  'return-assess-or-stop': {
    id: 'return-assess-or-stop',
    title: 'Évaluer ou arrêter un lot après retour',
    href: '/inventory/lots',
  },
};

export function flowMeta(id: string): FlowMeta | undefined {
  return FLOW_META[id];
}

export function flowMetaTitle(id: string): string {
  return FLOW_META[id]?.title ?? id;
}
